import {reactive} from 'vue'

export const AnswerStore = reactive({
    //Number of words
    wordcounts: {},
    //Whether the word count should contribute to the total
    countwords: {},
    //Last modified time for the answer
    lastmodifieds: {},
    //Does the answer satisfy the requirements of the question
    satisfiedes: {},
    //Required
    requireds: {},
    //The answers themselves
    answers: {}


})